import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import ErrorTrackingService from './errorTrackingService';
import httpCommonHeaders from './httpCommonHeaders';

export const getLeadingProducts = async (dealId) => {
  if (!dealId) return;
  try {
    const { data } = await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/lead-products/deal/${dealId}`,
    });

    return data;
  } catch (error) {
    ErrorTrackingService.logError(error);
    throw new Error(error);
  }
};
